export enum CommonOrderWorkType {
    RIDE = "RIDE",
    USE = "USE",
    REPAIR = "REPAIR",
    WAIT = "WAIT",
    PAUSE = "PAUSE",
    OTHER = "OTHER",
}
